"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var SearchBar_styles_1 = require("./SearchBar.styles");
var constants_1 = require("../constants");
var LargeClose_1 = __importDefault(require("../icons/LargeClose"));
var Search_1 = __importDefault(require("../icons/Search"));
function SearchBarInput(_a) {
    var focusOnInitialRender = _a.focusOnInitialRender, getInputProps = _a.getInputProps, handleClearText = _a.handleClearText, handleInputOnChange = _a.handleInputOnChange, handleInputOnFocus = _a.handleInputOnFocus, handleKeyDown = _a.handleKeyDown, inputValue = _a.inputValue, isOpen = _a.isOpen;
    var hasInput = inputValue.length > 0;
    var inputRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(function () {
        if (!inputRef.current)
            return;
        if (focusOnInitialRender) {
            inputRef.current.focus();
        }
        else if (!isOpen) {
            inputRef.current.blur();
        }
    }, [focusOnInitialRender, isOpen]);
    var handleClearClick = (0, react_1.useCallback)(function () {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        handleClearText();
    }, [handleClearText]);
    return (react_1.default.createElement(SearchBar_styles_1.SearchBarInnerWrapper, null,
        react_1.default.createElement("div", { className: "flex pl-12 pr-8" },
            react_1.default.createElement(Search_1.default, null)),
        react_1.default.createElement("input", __assign({ className: "h-full flex-1 border-none bg-transparent text-base outline-none", placeholder: "Search Make, Model, or Keyword", type: "search" }, getInputProps({
            ref: inputRef,
            value: inputValue,
            onFocus: handleInputOnFocus,
            onChange: handleInputOnChange,
            onKeyDown: handleKeyDown
        }))),
        hasInput ? (react_1.default.createElement("button", { "aria-label": "clear text", className: "flex items-center bg-transparent p-16 text-grey-3", "data-analytics-id": constants_1.SearchBarEvents.ClearedText, onClick: handleClearClick, title: "Clear Text", type: "button" },
            react_1.default.createElement(LargeClose_1.default, null))) : null));
}
exports.default = SearchBarInput;
//# sourceMappingURL=SearchBarInput.js.map